import React from 'react';
import { GenericAlphaNumericInput } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isValidEmailAddress } from '../../../utils/validation';

const EmailAddress = ({ disabled = false }) => (
  <Content>
    {({ businessContactDetailsEmailLabel = '', businessContactDetailsEmailError = '' }) => (
      <Field name="emailAddress" subscription={{ touched: true, error: true }}>
        {({ meta: { touched, error } }) => (
          <GenericFieldWrapper
            name="emailAddress"
            title={businessContactDetailsEmailLabel}
            validationMessage={touched && !!error ? businessContactDetailsEmailError : ''}
          >
            <Field name="emailAddress" component="input" validate={isValidEmailAddress}>
              {({ input }) => (
                <GenericAlphaNumericInput
                  id="emailAddress"
                  name="emailAddress"
                  type="email"
                  {...input}
                  disabled={disabled}
                  onChange={(changedValue) => {
                    input.onChange(changedValue.value);
                  }}
                />
              )}
            </Field>
          </GenericFieldWrapper>
        )}
      </Field>
    )}
  </Content>
);

export default EmailAddress;
